// src/router/index.js
import { createRouter, createWebHashHistory } from "vue-router";
import { useCounterStore } from "../stores/counterStore"; // 导入 Pinia Store

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("../components/Login.vue"), // 懒加载登录组件
    meta: { showHeader: false }, // 不显示头部
  },
  {
    path: "/H5",
    name: "h5",
    component: () => import("@/components/H5.vue"), // 懒加载登录组件
    meta: { showHeader: false }, // 不显示头部
  },
  {
    path: "/",
    component: () => import("../components/Layout.vue"), // 使用布局组件
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("../views/home.vue"), // 懒加载主页面组件
        meta: { showHeader: true, requiresAuth: true }, // 显示头部并需要身份验证
      },
      {
        path: "smartClassroom",
        name: "smartClassroom",
        component: () => import("../views/SupervisionManagement/smartClassroom.vue"), // 懒加载主页面组件
        meta: { showHeader: true, requiresAuth: true }, // 显示头部并需要身份验证
        props:(route) =>({
          token:route.query.token,
          user_uuid: route.query.user_uuid,
          room_uuid: route.query.room_uuid,
          room_name: route.query.room_name,
          user_name: route.query.user_name,
          role_type: route.query.role_type,
          room_type: route.query.room_type,
          duration: route.query.duration,
        })
      },
      {
        path: "contact",
        name: "contact",
        component: () => import("../views/contact.vue"), // 懒加载主页面组件
        meta: { showHeader: true, requiresAuth: true }, // 显示头部并需要身份验证
      },
      {
        path: "staffmanagement",
        name: "staffmanagement",
        component: () => import("../views/staffmanagement.vue"), // 懒加载主页面组件
        meta: { showHeader: true, requiresAuth: true }, // 显示头部并需要身份验证
      },
      {
        path: "roles",
        name: "roles",
        component: () => import("../views/roles.vue"), // 懒加载主页面组件
        meta: { showHeader: true, requiresAuth: true }, // 显示头部并需要身份验证
      },
      {
        path: "systemlog",
        name: "systemlog",
        component: () => import("../views/systemlog.vue"), // 懒加载主页面组件
        meta: { showHeader: true, requiresAuth: true }, // 显示头部并需要身份验证
      },
      {
        path: "agent",
        name: "agent",
        component: () => import("../views/agent.vue"), // 懒加载主页面组件
        meta: { showHeader: true, requiresAuth: true }, // 显示头部并需要身份验证
      },
      {
        path:'integralmanage/:id',
        name:'integralmanage',
        component: () => import("../views/integralmanage.vue"), // 懒加载主页面组件
        meta: { 
          showHeader: true, 
          requiresAuth: true,
          breadcrumb: [
            { name: '代理商管理', path: '/agent' },
            { name: '积分管理', path: '' }
          ]
        }, // 显示头部并需要身份验证
      },
      {
        path: "/inventory/:id", // 去掉多余的引号
        name: "inventory",
        component: () => import("../views/inventory.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "examine",
        name: "examine",
        component: () => import("../views/toexamine.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "openrecord",
        name: "openrecord",
        component: () => import("../views/openrecord.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "viewTheReport",
        name: "viewTheReport",
        component: () => import("../views/viewTheReport.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "Inventorydetails",
        name: "Inventorydetails",
        component: () => import("../views/Inventorydetails.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "studentlist/:id",
        name: "studentlist",
        component: () => import("../views/studentlist.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true, keepAlive: true }, // 需要身份验证 & 缓存页面
      },
      {
        path: "newstudentlist/:id",
        name: "newstudentlist",
        component: () => import("../views/newstudentlist.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "/salesRecord/:id", // 去掉多余的引号
        name: "salesRecord",
        component: () => import("../views/salesRecord.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "studentdetails/:id",
        name: "studentdetails",
        component: () => import("../views/studentdetails.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "individualClassSchedule/:id",
        name: "individualClassSchedule",
        component: () => import("../views/individualClassSchedule.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "classList",
        name: "classList",
        component: () => import("../views/classList.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "assignmentlist",
        name: "assignmentlist",
        component: () => import("../views/assignmentlist.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "assignhomework",
        name: "assignhomework",
        component: () => import("../views/assignhomework.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "sucailist",
        name: "sucailist",
        component: () => import("../views/sucailist.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "coursemanagement",
        name: "coursemanagement",
        component: () => import("../views/coursemanagement.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "disciplinemanagement",
        name: "disciplinemanagement",
        component: () => import("../views/disciplinemanagement.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "grademanagement",
        name: "grademanagement",
        component: () => import("../views/grademanagement.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "studenthomework/:task_id/:course_id/:directory_id",
        name: "studenthomework",
        component: () => import("../views/studenthomework.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "testquestions",
        name: "testquestions",
        component: () => import("../views/testquestions.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "videomanagement/:id",
        name: "videomanagement",
        component: () => import("../views/videomanagement.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "contentmanagement",
        name: "contentmanagement",
        component: () => import("../views/contentmanagement.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "columnList",
        name: "columnList",
        component: () => import("../views/columnList.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "columnmanagement/:id",
        name: "columnmanagement",
        component: () => import("../views/columnmanagement.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "learningrecord",
        name: "learningrecordt",
        component: () => import("../views/learningrecord.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "mgxwjjwjgl",
        name: "mgxwjjwjgl",
        component: () => import("../views/mgxwjjwjgl.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "mgxwjjwj/:id",
        name: "mgxwjjwj",
        component: () => import("../views/mgxwjjwj.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "attractinvestment",
        name: "attractinvestment",
        component: () => import("../views/attractinvestment.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "salesranking",
        name: "salesranking",
        component: () => import("../views/salesranking.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "homeworkcontent/:id",
        name: "homeworkcontent",
        component: () => import("../views/homeworkcontent.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "classdetails",
        name: "classdetails",
        component: () => import("../views/classdetails.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "classstatistics",
        name: "classstatistics",
        component: () => import("../views/classstatistics.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "EvaluationRecord/:id",
        name: "evaluationrecord",
        component: () => import("../views/evaluationrecord.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "aIEvaluation/",
        name: "aIEvaluation",
        component: () => import("../views/aIEvaluation.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "Superintendent",
        name: "superintendent",
        component: () => import("../views/superintendent.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "mfkglfklb",
        name: "mfkglfklb",
        component: () => import("../views/mfkglfklb.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "mhyglhylb",
        name: "mhyglhylb",
        component: () => import("../views/mhyglhylb.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "mhyglhydd",
        name: "mhyglhydd",
        component: () => import("../views/mhyglhydd.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "productCategory",
        name: "productCategory",
        component: () => import("../views/productCategory.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "productList",
        name: "productList",
        component: () => import("../views/productList.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "productAdd",
        name: "productAdd",
        component: () => import("../views/productAdd.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "productAdd/:id",
        name: "productEdit",
        component: () => import("../views/productAdd.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "shitingkelb",
        name: "shitingkelb",
        component: () => import("../views/shitingkelb.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "shitingkeqd",
        name: "shitingkeqd",
        component: () => import("../views/shitingkeqd.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "shitingkesh",
        name: "shitingkesh",
        component: () => import("../views/shitingkesh.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "mhdglhdlb",
        name: "mhdglhdlb",
        component: () => import("../views/mhdglhdlb.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "relationalgraph",
        name: "relationalgraph",
        component: () => import("../views/relationalgraph.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "Supervision_Room",
        name: "Supervision_Room",
        component: () => import("../views/SupervisionManagement/individualClassSchedule.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      //订单管理
      {
        path: "orderManaget", 
        name: "orderManaget",
        component: () => import("../views/orderManaget.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "xtglddgl",
        name: "xtglddgl",
        component: () => import("../views/xtglddgl.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "RoomInfo/:id",
        name: "RoomInfo",
        component: () => import("../views/Supervision_RoomList.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "classplanlist",
        name: "classplanlist",
        component: () => import("../views/classplan/classplanlist.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "messlist",
        name: "messlist",
        component: () => import("../views/mess.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: "classhourrecord",
        name: "classhourrecord",
        component: () => import("../views/classhourrecord.vue"), // 懒加载代理商列表组件
        meta: { requiresAuth: true }, // 需要身份验证
      },
      {
        path: '/bmsjlb',
        name: 'bmsjlb',
        component: () => import('@/views/bmsjlb.vue'),
        meta: {
          title: '报名数据列表'
        }
      },
      {
        path: '/batch-create',
        name: 'BatchCreate',
        component: () => import('@/views/BatchCreate.vue'),
        meta: {
          title: '批量上传'
        }
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(), // 使用 Hash 模式
  routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const store = useCounterStore();
  const token = store.token;

  if (to.meta.requiresAuth && !token) {
    // 如果需要登录但没有token，重定向到登录页
    next({ name: 'login' });
  } else {
    next();
  }
});

export default router;
